module.exports = __webpack_public_path__ + "media/checkout/secure-min-07cd2610.png";